import { useMutation } from '@tanstack/react-query'
import { approveBabysitter } from '../index'

const usePostApproveBabysitter = () =>
  useMutation({
    mutationFn: approveBabysitter,
  })

export { usePostApproveBabysitter }
